export default __webpack_public_path__ + "static/works-image4-4d278ab6af0f45bfa7f4727acb008f6a.jpg";